import angular from 'angular';

import { FavouritesComponent } from './favourites.component';
import favouriteService from './service/favourites-service.module';
import login from './../../frame/header/login/login.module';
import shareInEmail from './../share-with-copy-link-and-email/share-in-email/share-in-email.module';
import messagingService from './../messaging/messaging.module';
import WebWalk from './../webwalk-util/webwalk.module';

const MODULE_NAME = 'favourites';

export default angular.module(MODULE_NAME, [favouriteService, login, shareInEmail, messagingService, WebWalk]).component('favourites', FavouritesComponent)
	.name;
